import { render, staticRenderFns } from "./DspTool.vue?vue&type=template&id=4d804ebb&scoped=true"
import script from "./DspTool.vue?vue&type=script&lang=js"
export * from "./DspTool.vue?vue&type=script&lang=js"
import style0 from "./DspTool.vue?vue&type=style&index=0&id=4d804ebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d804ebb",
  null
  
)

export default component.exports